import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { Link, List, ListItem, ListItemIcon } from "@mui/material";

type Document = {
  title: string;
  url: string;
};

type Props = {
  documents: Array<Document>;
};

export const DocumentsList = ({ documents }: Props) => (
  <List dense disablePadding>
    {documents.map(({ url, title }) => (
      <ListItem key={url}>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <DescriptionOutlinedIcon />
        </ListItemIcon>
        <Link
          target="_blank"
          href={url}
          sx={({ palette }) => ({
            color: palette.text.primary,
            textDecorationColor: palette.text.secondary,
          })}
        >
          {title}
        </Link>
      </ListItem>
    ))}
  </List>
);
